import { parseCourseCode } from "@/utils/parseCourseCode";
const PLACEHOLDER_COURSES = new Set(["FAIR", "FER", "EXTERNO"]);
export const surveyOptionLabel = (question, optionId) => {
    if (!question)
        return optionId;
    const opts = question.options || [];
    const opt = opts.find((o, i) => {
        const id = "optionId" in o ? o.optionId : undefined;
        const value = "value" in o ? o.value : undefined;
        const fallback = `opt_${i + 1}`;
        const opFallback = `op${i + 1}`;
        return (id === optionId ||
            value === optionId ||
            fallback === optionId ||
            opFallback === optionId);
    });
    return opt?.label || optionId;
};
export const formatSurveyAnswerDisplay = (row, question) => {
    if (!question)
        return "—";
    const a = row.answers?.find((x) => x.questionId === question.questionId);
    if (!a)
        return "—";
    const v = a.value;
    const type = String(question.type || "");
    if (type === "RANKING" && Array.isArray(v)) {
        return v
            .map((id, idx) => `${idx + 1}. ${surveyOptionLabel(question, String(id))}`)
            .join(" → ");
    }
    if ((type === "MULTIPLE_CHOICE_SINGLE" || type === "MULTIPLE_CHOICE_MULTI") &&
        Array.isArray(v)) {
        return v
            .map((id) => surveyOptionLabel(question, String(id)))
            .join(", ");
    }
    if (type === "MULTIPLE_CHOICE_SINGLE" ||
        type === "MULTIPLE_CHOICE_MULTI") {
        return surveyOptionLabel(question, String(v));
    }
    if (typeof v === "boolean")
        return v ? "Sí" : "No";
    if (Array.isArray(v))
        return v.join(", ");
    return String(v ?? "—");
};
export const formatSurveyCourseLabel = (courseCode) => {
    const code = String(courseCode || "").trim();
    if (!code)
        return "—";
    const upper = code.toUpperCase();
    if (upper === "EXTERNO" || upper === "FAIR" || upper === "FER") {
        return upper === "EXTERNO" ? "Externo" : "Feria";
    }
    if (PLACEHOLDER_COURSES.has(upper))
        return code;
    try {
        return parseCourseCode(code).longName || code;
    }
    catch {
        return code;
    }
};
export const surveyAnswerPreview = (text, maxLen = 80) => {
    const full = String(text || "").trim() || "—";
    if (full.length <= maxLen) {
        return { preview: full, full, truncated: false };
    }
    return {
        preview: `${full.slice(0, maxLen - 1)}…`,
        full,
        truncated: true,
    };
};
export const sortedSurveyQuestions = (survey) => {
    const qs = survey?.questions ?? [];
    return [...qs].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
};
